import SchoolListingPage from "./schoolListingPage"

export default SchoolListingPage;